import * as React from 'react';
import * as _ from 'underscore';

import { Location } from '../../common/react/Location';
import { Module } from '../Module';
import { MobileAppService } from '../services/MobileAppService';

interface IAppBannerScope extends ng.IScope {
  props: AppBannerContent.Props;
}

Module.instance().directive('tbAppBanner', [
  '$rootScope',
  '$cookies',
  '$location',
  'MobileAppService',
  '$translate',
  (
    $rootScope: ng.IRootScopeService,
    $cookies: ng.cookies.ICookiesService,
    $location: ng.ILocationService,
    mobileAppService: MobileAppService,
    $translate: ng.translate.ITranslateService,
  ) => {
    return {
      link: (scope: IAppBannerScope) => {
        scope.props = {
          shouldShowAppBanner: shouldShowAppBanner(),
          translate: $translate,
          redirectToApp: () => {
            const queryParams = $location.search();
            const deepLink = mobileAppService.createDeepLink(queryParams.redirect, queryParams.externalRedirect);
            mobileAppService.maybeRedirectToApp(deepLink);
          },
          closeAppBanner: () => {
            // closing the banner will hide the banner for 7 days
            const expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 7);
            $cookies.put(MobileAppService.HIDE_APP_BANNER_COOKIE, 'true', { 'expires': expireDate });
            scope.$apply(() =>
              scope.props = _.extend({}, scope.props, { shouldShowAppBanner: false }));
          },
        };

        function shouldShowAppBanner() {
          return mobileAppService.shouldShowAppBanner(Location.instance.href());
        }

        // This is necessary since this directive gets loaded before the translate service
        // is initialized with a language
        $rootScope.$on('$translateChangeSuccess', () => {
          scope.props = _.clone(scope.props); // "change" the props so the child re-renders
        });

        scope.$on('$locationChangeSuccess', () => {
          const showAppBanner = shouldShowAppBanner();
          scope.props = {
            ...scope.props,
            shouldShowAppBanner: showAppBanner
          };
        });
      },
      template: '<tb:app-banner-content props="props"></tb:app-banner-content>',
    };
  }

] as any[]);

export function AppBannerContent(props: AppBannerContent.Props) {
  if (props.shouldShowAppBanner) {
    return (
      <div className="tb-app-banner">
        <img className="tb-app-banner-close"
          src="img/close_app_banner.png"
          onClick={props.closeAppBanner} />
        <img className="tb-banner-logo"
          src="img/banner-logo-96.png" />
        <a className="tb-app-banner-link-area"
          onClick={props.redirectToApp}>
          <p className="tb-app-banner-text-area">
            <span>Tableau</span>
            <span className="tb-app-banner-link-text">{props.translate.instant('openInTableauMobile')}</span>
          </p>
        </a>
      </div>
    );
  } else {
    return null;
  }
}

export namespace AppBannerContent {
  export interface Props {
    redirectToApp: () => void;
    closeAppBanner: () => void;
    shouldShowAppBanner: boolean;
    translate: ng.translate.ITranslateService;
  }
}
